<!-- =========================================================================================
    File Name: TablePacchetti.vue
    Description:
    ----------------------------------------------------------------------------------------
    Item Name:
      Author:
    Author URL:
========================================================================================== -->


<template>
  <div>
    <search-bar @find="cercaPacchetti" @create="handleNew" :p="{current:this.page, tot:this.tot_page}" :newTexts="['Nuovo']"></search-bar>
    <vs-table @next="nextPage" @prev="prevPage" :hasNext="hasNext" :page="page"  
      :custom_pager="{current:this.page, tot:this.tot_page}"
      :pagination="pacchetti.length >= elements_per_page || page != 1"
      v-if="pacchetti.length > 0"
      :max-items="elements_per_page"
      v-model="selected"
      @selected="handleSelected($event)"
      :data="pacchetti"
      >
        <template slot="thead">
          <vs-th>Nome</vs-th>
          <vs-th>Servizio</vs-th>
          <vs-th>Tariffa</vs-th>
          <vs-th>N. voci selezionate</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].nome" >
                {{data[indextr].nome}}
            </vs-td>
            <vs-td :data="data[indextr].servizio" >
                {{data[indextr].servizio.codice}}
            </vs-td>
            <vs-td :data="data[indextr].tariffa" >
                {{data[indextr].tariffa.nome}}
            </vs-td>
            <vs-td :data="data[indextr].tariffa_servizi" >
                {{data[indextr].tariffa_servizi.length}}
            </vs-td>
          </vs-tr>
        </template>
    </vs-table>
    <vs-sidebar click-not-close position-right parent="body" color="primary" class="sidebarx sidebarpage sidebar-pacchetti" spacer v-model="isSidebarActive">
      <sidebar-form-pacchetto @close-me="sidebarClose" @elimina-pacchetto="handleEliminaPacchetto($event)" @pacchetto-salvato="handleSave" v-if="sidebar_type === 'form'" :key="formkey" :selected="selected"></sidebar-form-pacchetto>
    </vs-sidebar>
  </div>
</template>

<script>
import axios from 'axios'
import SidebarFormPacchetto from './SidebarFormPacchetto.vue'
import SearchBar from '../commons/SearchBar.vue'

export default {
    data() {
        return {
            selected: null,
            sidebar_type: '',
            sidebar_active: false,
            pacchetti: [],
            formkey: Math.random(),
            keyword: "",
            page: 1,
            tot_page: 0,
            hasNext: false,
            elements_per_page: 15,
            haveSaved: false,
        }
    },
    components: {
      SidebarFormPacchetto,
      SearchBar,
    },
    mounted () {
      this.getPacchetti()
    },
    methods: {
        handleSelected() {
            this.formkey = Math.random()
            this.sidebar_type = 'form'
            this.sidebar_active = !this.sidebar_active
        },

        handleNew() {
          this.sidebar_type = 'form'
          this.formkey = Math.random()
          this.selected = null
          this.sidebar_active = !this.sidebar_active
        },

        getPacchetti() {
          axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/trova_pacchetti_live', {
            pag: this.page,
            keyword: this.keyword,
            take: this.elements_per_page
          },{headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                    withCredentials: true,
          }).then(response => {
                    this.pacchetti = response.data.res
                    this.hasNext = this.pacchetti.length >= this.elements_per_page
                    this.tot_page = Math.ceil(response.data.count / this.elements_per_page)
                  })
          .catch(e => console.log(e))
        },

        nextPage() {
          this.page += 1
          this.getPacchetti()
        },

        prevPage() {
          this.page -= 1
          this.getPacchetti()
        },

        handleSave() {
          this.isSidebarActive = !this.sidebar_active
          this.haveSaved = true
          this.formkey = Math.random()
          this.selected = null
          this.page = 1
          this.keyword = ""
          this.getPacchetti()
        },

        handleEliminaPacchetto() {
          this.isSidebarActive = !this.sidebar_active
          this.boardkey = Math.random()
          axios.post(process.env.VUE_APP_BACKEND_API+'/tariffa_servizio/elimina_pacchetto', { id: this.selected.id },{
              headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
              withCredentials: true,
            })
            .then(response => {
              this.message = response.data
              this.selected = null
              this.haveSaved = true
              this.getPacchetti()
            })
            .catch(e => console.log(e))
        },

        sidebarClose() {
          this.selected = null
          this.sidebar_active = false
        },

        cercaPacchetti(k) {
          this.keyword = k
          this.page = 1
          this.getPacchetti()
        },
    },
    computed: {
      isSidebarActive: {
        get() {
          return this.sidebar_active
        },
        set(val) {
          if(!val && this.haveSaved) {
            this.haveSaved = false
          }
          else {
            this.sidebar_active = val
          }

        }
      }
    }
}
</script>
